import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-obsidian px-5">
      <form
        data-testid="admin-login-form"
        onSubmit={submit}
        className="w-full max-w-sm rounded-sm border border-white/10 bg-white/[0.03] p-8 backdrop-blur-md"
      >
        <img src="/logo.png" alt="Nivaan Experiences logo" className="mx-auto h-14 w-14 rounded-full object-cover" />
        <p className="mt-3 text-center font-serif text-2xl font-medium tracking-[0.35em] text-zinc-100">NIVAAN</p>
        <p className="mt-1 text-center text-[9px] font-mono uppercase tracking-[0.4em] text-gold">Admin</p>
        <div className="mt-8 space-y-5">
          <input
            data-testid="admin-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
            className="w-full rounded-sm border border-white/15 bg-white/[0.04] px-4 py-3 text-sm font-light text-zinc-100 placeholder-zinc-500 outline-none focus:border-gold"
          />
          <input
            data-testid="admin-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
            className="w-full rounded-sm border border-white/15 bg-white/[0.04] px-4 py-3 text-sm font-light text-zinc-100 placeholder-zinc-500 outline-none focus:border-gold"
          />
          <button
            data-testid="admin-login-button"
            type="submit"
            disabled={loading}
            className="flex w-full items-center justify-center gap-2 rounded-full bg-gold px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-obsidian transition-colors hover:bg-gold-hover disabled:opacity-60"
          >
            {loading && <Loader2 size={14} className="animate-spin" />}
            Sign In
          </button>
        </div>
      </form>
    </div>
  );
}
